import React, {useState, useEffect} from 'react';
import {Card, Row, Col, Button} from 'react-bootstrap';
import { dailyReviews, overallReviews } from '../services/dashboardServices';
import {FaChartLine, FaChartBar, FaBars, FaCoins, FaMoneyBill, FaBell, FaUsers, FaVrCardboard, FaPhotoVideo, FaSlidersH} from 'react-icons/fa'
import { useSelector } from 'react-redux';
import { getDashboardSummary } from '../../api/api';
import { useNavigate } from 'react-router-dom';
// import { getAllTimeReviews, getDailyReviews } from '../api/api';


const Dashboard = () => {
//    const myStyle = useSelector(state => state.style.payload);
    const navigate = useNavigate();
   const user = useSelector(state => state.user.payload);
   const reviews = useSelector(state => state.reviews.payload);

   const dReviews = useSelector(state => state.dailyReviews.payload);
   const atReviews = useSelector(state => state.allTimeReviews.payload);

//    function fetchDailyReviews(){
//     cons
//    }
console.log(reviews);
useEffect(() => {
    !reviews.members && getDashboardSummary();
    !reviews.members && console.log('Working well');
}, [])
   useEffect(() => {
    // console.log(myStyle.marginLeft);
    document.title = 'Dashboard | Bida Sport Club'
    
   }, [])
  return dReviews && atReviews && (
   
<div className='mt-2 m-0 pt-4'>
{/* <div className='col-lg-2 col-sm-2 col-xs-2' >
<MySidebar/>
</div> */}
{/* <MySidebar/> */}

<div id='' className='position-relative top-0 end-0  '
style={{  }}
>
<h2 className='text-center my-2'> <b> System Summaries </b>  </h2>
    <div className='mt-2 mx-1 my-4 card'>
        {/* <h4 className='text-start ms-4 mt-2'> <b>Daily Reviews</b> </h4> */}
        <div className='d-flex justify-content-end align-items-center pe-4'>
                
                </div>
            <div className='row mx-2'>
                
            { dailyReviews && dailyReviews.map((daily, idx) => (
                <div className={daily.icon === 'notification' ? 'col-12':'col-xs-12 col-sm-6 col-md-4 col-lg-4'}> 
                    <div className='d-flex justify-content-center card dashboard-card my-2'>
                        <>
                        <h6 className='title'>
                        {
                        daily.icon === 'members' && <FaUsers size='30' /> 
                        }
                        {
                        daily.icon === 'events' && <FaVrCardboard size='30' />
                        }
                        {
                        daily.icon === 'gallery' && <FaPhotoVideo size='30' /> 
                        }
                        {
                        daily.icon === 'payments' && <FaCoins size='30' />
                        }
                        {
                        daily.icon === 'highlights' && <FaPhotoVideo size='30' />
                        }
                        {
                        daily.icon === 'sliders' && <FaSlidersH size='30' />
                        }
                        {
                        daily.icon === 'notification' && <FaBell size='25' />
                        }

                        <b> {` ${daily.title}`} </b>
                        </h6> 
                        <small className='body'>
                            {daily.icon == 'members' && ` ${reviews.members}`}
                            {daily.icon == 'events' && ` ${reviews.events}`}
                            {daily.icon == 'gallery' && ` ${reviews.gallery}`}
                            {daily.icon == 'payments' && ` ₦`}
                            {daily.icon == 'highlights' && `0`}
                            {daily.icon == 'sliders' && ` ${reviews.slides}`}
                            {daily.icon == 'notification' && <a href='#'
                            style={{ 
                                textDecoration: 'none',
                                color: 'black',
                                fontWeight: 400
                             }}
                             onClick={ () => navigate('/messages')}
                            ><i>A new message from {reviews.messages && reviews.messages.name}</i></a>}
                            {/* {  daily.old && 
                            <span>
                                <b>Read: </b> {daily.old}
                            </span>
                            } */}
                        </small>
                        </>
                    </div>
                </div>
            ))}
            </div>
    </div>

</div>
</div>

  )
}

export default Dashboard